import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authAPI from '../../services/authAPI';
import AuthShell, { inputClass, labelClass, buttonClass, Notice } from '../../components/Auth/AuthShell';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await authAPI.requestPasswordReset(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.response?.status === 429
        ? 'Too many requests. Please wait a while and try again.'
        : 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle={sent ? null : "Enter your account's email and we'll send you a link to choose a new password."}
    >
      {sent ? (
        <div className="space-y-6">
          <Notice tone="success">
            If an account exists for <strong>{email.trim()}</strong>, a reset link is on its way. It expires in 24 hours.
            Check your spam folder if it doesn't arrive within a few minutes.
          </Notice>
          <Link to="/login" className={buttonClass}>Back to sign in</Link>
        </div>
      ) : (
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className={labelClass}>Email address</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputClass}
              placeholder="Email address"
            />
          </div>
          {error && <Notice>{error}</Notice>}
          <button type="submit" disabled={loading} className={buttonClass}>
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
          <p className="text-center text-sm text-gray-600 dark:text-gray-400">
            Remembered it?{' '}
            <Link to="/login" className="font-medium text-primary-300 hover:text-primary-200">Sign in</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPasswordPage;
